import api from './api';
import { User } from '../types';

export interface RegisterAssociationData {
  name: string;
  email: string;
  password: string;
  cnpj?: string;
  phone?: string;
  cpf: string;
  city: string;
  state: string;
}

export interface RegisterUserData {
  name: string;
  email?: string;
  password: string;
  phone?: string;
  cpf: string;
  city: string;
  state: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface Association {
  slug: string;
  name: string;
  active: boolean;
}

export interface UserListItem {
  id: string;
  name: string;
  email?: string;
  cpf: string;
  city: string;
  state?: string;
  phone?: string;
  createdAt: string;
  couponCount: number;
}

export interface FindUsersFilters {
  search?: string;
  page?: number;
  limit?: number;
}

export interface UserCouponsByCampaign {
  campaignId: string;
  campaignName: string;
  campaignStatus: string;
  couponCount: number;
}

export interface UserDrawWin {
  drawId: string;
  campaignName: string;
  prizeName: string;
  status: string;
  winningDate: string;
}

export interface UserDetails {
  id: string;
  name: string;
  email?: string;
  cpf: string;
  phone?: string;
  city?: string;
  state?: string;
  createdAt: string;
  totalCoupons: number;
  couponsByCampaign: UserCouponsByCampaign[];
  drawWins: UserDrawWin[];
}

export const userService = {
  async registerAssociation(data: RegisterAssociationData) {
    const response = await api.post('/users/register-association', data);
    return response.data;
  },

  async register(data: RegisterUserData) {
    const response = await api.post('/users/register', data);
    return response.data;
  },

  async login(data: LoginData) {
    const response = await api.post('/users/login', data);
    return response.data;
  },

  async searchEndUsers(search?: string, limit?: number): Promise<User[]> {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (limit) params.append('limit', limit.toString());
    
    const response = await api.get(`/users/search?${params.toString()}`);
    return response.data;
  },

  async getProfile(): Promise<User> {
    const response = await api.get('/users/profile');
    return response.data;
  },

  async updateProfile(data: Partial<User>): Promise<User> {
    const response = await api.put('/users/profile', data);
    return response.data;
  },

  async getUsers(filters?: FindUsersFilters): Promise<{ users: UserListItem[]; total: number }> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString());
        }
      });
    }
    const response = await api.get(`/users?${params.toString()}`);
    return response.data;
  },

  async getUserDetails(id: string): Promise<UserDetails> {
    const response = await api.get(`/users/${id}/details`);
    return response.data;
  },

  async getActiveAssociations(): Promise<Association[]> {
    try {
      const response = await api.get('/users/associations');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar associações:', error);
      throw error;
    }
  },
}; 